import { render } from "./FAQView.vue?vue&type=template&id=33f5b868&scoped=true"
import script from "./FAQView.vue?vue&type=script&lang=js"
export * from "./FAQView.vue?vue&type=script&lang=js"

import "./FAQView.vue?vue&type=style&index=0&id=33f5b868&scoped=true&lang=css"

import exportComponent from "C:\\Users\\darca\\dev\\spanish-ai\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33f5b868"]])

export default __exports__